angular.module("varCoordBan.components", ['app.services']).component("varCoordBan", {
    templateUrl: "ng/components/varCoordBan/varCoordBan.view.html",
    bindings: {
        richiestePostVendita: "<"
    },
    controllerAs: "varCoordBanCtrl",
    controller: function VarCoordBan(
        $rootScope,
        $modalService,
        $location,
        $RichiestePostVenditaService,
        $arcService,
        Contratti,
        $download
    ) {
        var self = this;
        self.coordinateBancarie = {};

        self.$onInit = function () {
            self.showMapInfo = false;
            self.mapInfo = "";

            if (self.richiestePostVendita.viewIndex == 0) {
                self.richiestePostVendita.viewIndex = 1200;
            }
            var contratti = [];
            if (self.richiestePostVendita.metadata.coordinateBancarie.contratti.length == 0) {
                self.richiestePostVendita.metadata.ctrRichiestaList.forEach(function (contratto) {
                    contratti.push(Contratti.build({
                        numero: contratto.numeroContratto,
                        modulo: contratto.numeroModulo,
                        selected: true,
                        codProdotto: contratto.codProdotto
                    }));
                });

                self.richiestePostVendita.metadata.coordinateBancarie.contratti = contratti;
            }

            self.coordinateBancarie = self.richiestePostVendita.metadata.coordinateBancarie;

            if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1' || self.richiestePostVendita.readOnly) {
                self.popolateCheckListDownload();
                self.popolateCheckListUpload();
            }

            retrieveStepInfo();
        };

        self.handleChange = function (type, value) {
            switch (type) {
                case "contratti":
                    self.richiestePostVendita.metadata.coordinateBancarie.contratti = value;
                    break;
                case "iban":
                    self.richiestePostVendita.metadata.coordinateBancarie.iban = value.iban;
                    break;
                default:
                    break;
            }
        };

        self.ibanIsOk = function () {
            self.ibanOk = true;
            self.validityPage(self.ibanOk);
        };

        self.ibanIsNotOk = function () {
            self.ibanOk = false;
            self.validityPage(self.ibanOk);
        };

        self.backValidity = function () {
            return (self.getWizardMap(self.richiestePostVendita.viewIndex) !== 'PCB1') || self.richiestePostVendita.readOnly ? true : false;
        }

        self.next = function (fromModalShowSpesa) {
          self.enabledLoader = true;
          if (
            self.getWizardMap(self.richiestePostVendita.viewIndex) === "PCB1"
          ) {
            if (fromModalShowSpesa) {
              self.confirmingSpesa = true;
              $RichiestePostVenditaService
                .generateDocumentsPv(self.richiestePostVendita)
                .then(function (response) {
                  if (response.success) {
                    cleanPvModel(
                      self.richiestePostVendita.metadata,
                      self.richiestePostVendita.applicationName
                    );
                    $RichiestePostVenditaService
                      .nextStepPv(
                        self.richiestePostVendita,
                        self.richiestePostVendita.typeWf,
                        self.richiestePostVendita.applicationName,
                        true
                      )
                      .then(function (response) {
                        self.enabledLoader = false;
                        self.confirmingSpesa = false;
                        self.richiestePostVendita = response;
                        self.closeModal("showSpesaVba");
                        if (
                          self.getWizardMap(
                            self.richiestePostVendita.viewIndex
                          ) === "PCK1"
                        ) {
                          retrieveStepInfo();
                          self.popolateCheckListDownload();
                          self.popolateCheckListUpload();
                        }
                      })
                      .catch(function (error) {
                        console.log(error);
                        self.confirmingSpesa = false;
                        self.enabledLoader = false;
                      });
                  } else {
                    self.enabledLoader = false;
                  }
                })
                .catch(function (error) {
                  console.log(error);
                  self.enabledLoader = false;
                });
            } else {
              cleanPvModel(
                self.richiestePostVendita.metadata,
                self.richiestePostVendita.applicationName
              );
              acceptExpense();
            }
          } else if (
            self.getWizardMap(self.richiestePostVendita.viewIndex) === "PCK1"
          ) {
            // self.richiestePostVendita.metadata.variazioneAnagrafica.sedeConsegna.stato = self.richiestePostVendita.metadata.variazioneAnagrafica.sedeConsegna.stato.name;
            // self.richiestePostVendita.metadata.variazioneAnagrafica.sedeFatturazione.stato = self.richiestePostVendita.metadata.variazioneAnagrafica.sedeFatturazione.stato.name;
            // self.richiestePostVendita.metadata.variazioneAnagrafica.sedeLegale.stato = self.richiestePostVendita.metadata.variazioneAnagrafica.sedeLegale.stato.name;
            cleanPvModel(
              self.richiestePostVendita.metadata,
              self.richiestePostVendita.applicationName
            );
            $RichiestePostVenditaService
              .variazioneIban(
                self.richiestePostVendita.metadata.coordinateBancarie,
                self.richiestePostVendita.id,
                self.richiestePostVendita.viewIndex,
                self.richiestePostVendita.applicationName,
                self.richiestePostVendita.typeWf
              )
              .then(function () {
                self.enabledLoader = false;
                $location.path("/");
              })
              .catch(function (error) {
                console.log(error);
                self.enabledLoader = false;
              });
          }
        };

        self.back = function () {
            self.enabledBackLoader = true;
            if (self.richiestePostVendita.readOnly) {
                $location.path('/');
            } else {
                cleanPvModel(self.richiestePostVendita.metadata, self.richiestePostVendita.applicationName);
                $RichiestePostVenditaService
                    .backStepPv(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                    .then(function (response) {
                        self.enabledBackLoader = false;
                        self.richiestePostVendita = response;
                        retrieveStepInfo();
                    }).catch(function (error) {
                        console.log(error);
                        self.enabledBackLoader = false;
                    })
            }
        }

        self.closeModal = function (modalName) {
            $modalService.closeModal(modalName);
        }

        self.sospendi = function () {
            // self.richiestePostVendita.metadata.variazioneAnagrafica.sedeConsegna.stato = self.richiestePostVendita.metadata.variazioneAnagrafica.sedeConsegna.stato.name;
            // self.richiestePostVendita.metadata.variazioneAnagrafica.sedeFatturazione.stato = self.richiestePostVendita.metadata.variazioneAnagrafica.sedeFatturazione.stato.name;
            // self.richiestePostVendita.metadata.variazioneAnagrafica.sedeLegale.stato = self.richiestePostVendita.metadata.variazioneAnagrafica.sedeLegale.stato.name;
            cleanPvModel(self.richiestePostVendita.metadata, self.richiestePostVendita.applicationName);
            $RichiestePostVenditaService
                .suspendInstance(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                .then(function () {
                    $location.path('/');
                    $modalService.closeModal("suspendInstance");
                })
        }

        self.getWizardMap = function (viewIndex) {
            if ($rootScope.wizardMap.find(function (element) {
                return element.index == viewIndex;
            })) {
                return $rootScope.wizardMap.find(function (element) {
                    return element.index == viewIndex;
                }).viewName;
            }
        };

        self.formIsOk = function () {
            self.enableNext = true;
            self.validityPage(self.enableNext);
        }

        self.formIsNotOk = function () {
            self.enableNext = false;
            self.validityPage(self.enableNext);
        }

        self.validityPage = function (validity) {
            self.enableNext = validity;
        }

        self.validityUpload = function (validity) {
            self.enableUploadFile = validity;

        }

        self.nextValidity = function () {
            if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCB1') {
                return self.enableNext && self.ibanOk;
            } else if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1') {
                return self.enableUploadFile;
            }
        }

        self.popolateCheckListDownload = function () {
            self.restDownloadRunning = true;
            $arcService.downloadDocumentationRichiestaPostVendita(self.richiestePostVendita)
                .then(function (response) {
                    self.listOfDocumentDownload = response.listDocuments;
                    self.visibleDownloadChecklist = response.visible;
                    self.restDownloadRunning = false;

                    var docsDownloaded = self.listOfDocumentDownload && self.listOfDocumentDownload.every(function (element) {
                        return element.downloaded == true
                    })

                    if (docsDownloaded) {
                        self.validityPage(true);
                    }
                })
                .catch(function (error) {
                    console.error(error);
                    self.restDownloadRunning = false;
                })
        }

        self.popolateCheckListUpload = function () {
            self.restUploadRunning = true;
            $arcService.uploadDocumentationRichiestaPostVendita(self.richiestePostVendita)
                .then(function (response) {
                    self.listOfDocumentUpload = response.listDocuments;
                    self.visibleUploadChecklist = response.visible;
                    self.message = response.message;
                    if (!self.visibleUploadChecklist) {
                        self.validityUpload(true);
                    }
                    self.restUploadRunning = false;
                })
                .catch(function (error) {
                    console.error(error);
                    self.restUploadRunning = false;
                })
        }

        var retrieveStepInfo = function () {
            self.clearLabelInfo = true;
            $RichiestePostVenditaService
                .getStepInfo(self.richiestePostVendita.id, self.richiestePostVendita.viewIndex)
                .then(function (response) {
                    if (response.success) {
                        self.showMapInfo = response.showBeMessage;
                        self.mapInfo = response.message;
                        self.enabledLoader = false;
                    }
                    self.clearLabelInfo = false;
                })
                .catch(function (error) {
                    console.log(error);
                    self.enabledLoader = false;
                    self.clearLabelInfo = false;
                });
        }

        var acceptExpense = function () {
          self.enabledLoader = true;
          $RichiestePostVenditaService
            .showSpesaVba(self.richiestePostVendita)
            .then(function (response) {
              if (response.success) {
                self.message = response.message;
                self.listaSpese = response.spese;
                $modalService.openModal("showSpesaVba");
                self.enabledLoader = false;
              }
            })
            .catch(function (error) {
              console.log(error);
              self.enabledLoader = false;
            });
        };

        self.downloadScontistica = function () {
          var url = "/uni/download/service-infos/SCONTI_VBA/";
          $download.getGenericDownload(url).then(function (response) {
            console.log(response);
          });
        };
    }
});